import PropTypes from 'prop-types';
import { Icon } from '@material-ui/core';

import useGetVehicle from '../hooks/useGetVehicle';
import SeparatorTitle from '../ui/SeparatorTitle';
import formatNumber from '../utils/formatNumber';

export default function VehicleDataSheet({ className }) {
  const { vehicle } = useGetVehicle();

  const specs = [
    vehicle.brand && { name: 'Marca', value: vehicle.brand },
    vehicle.model && { name: 'Modelo', value: vehicle.model },
    vehicle.year && { name: 'Año', value: vehicle.year },
    vehicle.truckClass && {name: 'Clase', value: vehicle.truckClass},
    vehicle.rearAxlesCapacity && {name: 'Capacidad de ejes traseros', value: vehicle.rearAxlesCapacity},
    vehicle.fifthWheel && {name: 'Quinta rueda', value: vehicle.fifthWheel},
    vehicle.cab && {name: 'Cabina', value: vehicle.cab},
    vehicle.trim && { name: 'Versión', value: vehicle.trim },
    vehicle.bodyType && { name: 'Tipo de carrocería', value: vehicle.bodyType },
    vehicle.transmission && { name: 'Transmisión', value: vehicle.transmission },
    vehicle.motor && { name: 'Motor', value: vehicle.motor },
    vehicle.color && { name: 'Color exterior', value: vehicle.color },
    vehicle.interiorColor && { name: 'Color interior', value: vehicle.interiorColor },
    vehicle.fuelType && { name: 'Tipo de combustible', value: vehicle.fuelType },
    vehicle.doors && { name: 'Puertas', value: vehicle.doors },
    (vehicle.kms || vehicle.kms === 0) && { name: 'Kilometraje', value: formatNumber(vehicle.kms) },
    vehicle.engineUsage && {name: 'Horas de uso de motor', value: vehicle.engineUsage},
  ].filter(Boolean);

  return (
    <div className={className}>
      <SeparatorTitle>Ficha técnica</SeparatorTitle>
      <table className="w-full">
        <tbody className="md:flex md:flex-wrap">
          {specs.map(({ name, value }) => (
            <tr
              key={name}
              className="w-6/12 md:flex odd:bg-oddRow odd:text-oddRow-text md:odd:bg-transparent md:odd:text-black"
            >
              <td className="p-1 w-6/12 bold-text">
                <div className="flex">
                  <Icon className="text-base mr-2">check</Icon>
                  <div className="mr-2">{`${name}: `}</div>
                  <span className="font-bold">{value}</span>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

VehicleDataSheet.propTypes = {
  className: PropTypes.string,
};

VehicleDataSheet.defaultProps = {
  className: '',
};
